import { takeLatest, call } from 'redux-saga/effects';
import actionTypes from 'store/auth/actionTypes';
import api from 'store/api';
import { toast } from 'react-toastify';
import { URL } from '../../../constants/url';
import history from '../../../utils/history';
import { gtmReg } from '../../../utils/gtm/gtmLogin';

export function* confirmEmailGen(payload) {
  const { code } = payload;
  const email = localStorage.getItem('tempEmail');
  try {
    yield call(api, {
      method: 'post',
      url: URL.CONFIRM_EMAIL,
      data: {
        email,
        confirm_code: +code,
      },
    });
    history.push('/auth/register/successful');
    localStorage.removeItem('tempEmail');
    gtmReg();
  } catch (e) {
    // yield put(confirmEmail.success(e));
    yield call(toast.error, 'Error');
  }
}

export default function* listener() {
  yield takeLatest(actionTypes.CONFIRM_EMAIL, confirmEmailGen);
}
